<template>
  <div class="available-products">
    <h3>Available materials</h3>
    <div class="products-list">
      <ProductCard
          v-for="(product, key) in products"
          :product="product"
      />
    </div>
  </div>
</template>

<script>
import ProductCard from "./ProductCard"
import {mapGetters} from "vuex";

export default {
  components: {
    ProductCard
  },
  computed: {
    ...mapGetters({
      products: 'market/products',
    })
  },
}
</script>

<style lang="scss">
.available-products {
  .products-list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>